/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Container, Grid } from 'theme-ui';
import SectionHeader from 'components/section-header';
import FeatureCard from 'components/feature-card.js';
import Smart from 'assets/feature/smart.svg';
import Winner from 'assets/feature/winner.svg';
import Cloud from 'assets/feature/cloud.svg';
import Setting from 'assets/feature/setting.svg';
import Design from 'assets/feature/design.svg';
import Chat from 'assets/feature/chat.svg';

const data = [
  {
    id: 1,
    imgSrc: Smart,
    altText: 'Sales',
    title: 'Sales',
    text:
      'Visualise sales data with date-wise, part-wise, branch-wise and customer-wise analysis.',
  },
  {
    id: 2,
    imgSrc: Winner,
    altText: 'Order Management',
    title: 'Order Management',
    text:
      'Receive orders through part numbers and images, manage order statuses and back orders.',
  },
  {
    id: 3,
    imgSrc: Cloud,
    altText: 'Account & Outstanding',
    title: 'Account & Outstanding',
    text:
      'Manage sales returns, invoices, payments status and outstanding with just a click.',
  },
  {
    id: 4,
    imgSrc: Setting,
    altText: 'Inventory',
    title: 'Inventory',
    text:
      'View your part-line and showcase it to your customers. Track inventory days and stock value.',
  },
  {
    id: 5,
    imgSrc: Design,
    altText: 'Schemes',
    title: 'Schemes',
    text:
      'Promotions and scheme creation in few clicks with realtime notifications & updates.',
  },
  {
    id: 6,
    imgSrc: Chat,
    altText: 'Smart Insights',
    title: 'Smart Insights',
    text:
      'Analyse and derive tasks to be performed using insights based on previous billings.',
  },
];

export default function Feature() {
  return (
    <section sx={{ variant: 'section.feature' }}>
      <Container>
        <SectionHeader
          slogan="Distributor SaaS features"
          title="Feature Highlights to get you started"
        />

        <Grid sx={styles.grid}>
          {data.map((item) => (
            <FeatureCard
              key={item.id}
              src={item.imgSrc}
              alt={item.title}
              title={item.title}
              text={item.text}
            />
          ))}
        </Grid>
      </Container>
    </section>
  );
}

const styles = {
  grid: {
    pt: [0, null, null, null, null, null, null, 3],
    gridGap: [
      '37px 0',
      null,
      '45px 30px',
      null,
      '50px 30px',
      null,
      null,
      '90px 70px',
    ],
    width: ['100%', '80%', '100%'],
    mx: 'auto',
    gridTemplateColumns: [
      'repeat(1,1fr)',
      null,
      'repeat(2,1fr)',
      null,
      'repeat(3,1fr)',
    ],
  },
};
